export class  AbstractDocument{
    public id!:number;
    public date?:Date;
    public name?:string;
    public description?:string;
    public typeId!:number;
    public isLegalAd:boolean = false;
    public contentType?:string;
    public visibility?:number;
    public visibleTo?:number; //roles bitmask, see VisibleTo
    public documentReference!:string;
    public folderStructurePath?:string;
    public userName?:string;
    public userFullName?:string;

    
    get isBuyerExecuted():boolean{
        return this.typeId===4 || this.typeId===5 || this.typeId===6;
    }
  }